import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from '../app';
import Component from '../Component';
import Input from './Input';

/**
 * The `SearchSource` interface defines a tab of search results in the
 * search modal.
 *
 * Search sources should be registered with the `GlobalSearch` component class
 * by extending the `sourceItems` method. When the user types a
 * query, each search source will be prompted to load search results via the
 * `search` method. When the search modal's dropdown is redrawn, it will be constructed by
 * putting together the output from the `view` method of each source.
 */

/**
 * The `Search` component displays a primary search input at the top of the frontend (forum or admin).
 * When clicked, it opens an advanced search modal with results from various sources.
 *
 * Must be extended and the abstract methods implemented per-frontend.
 */
export default class AbstractGlobalSearch extends Component {
  constructor() {
    super(...arguments);
    /**
     * The instance of `SearchState` for this component.
     */
    _defineProperty(this, "searchState", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.searchState = this.attrs.state;
  }
  view() {
    // Hide the search view if no sources were loaded
    if (this.sourceItems().isEmpty()) return m("div", null);
    const openSearchModal = () => {
      this.$('input').blur() && app.modal.show(() => import(/* webpackChunkName: 'common/components/SearchModal', webpackMode: 'lazy-once' */ '../../common/components/SearchModal'), {
        searchState: this.searchState,
        sources: this.sourceItems().toArray()
      });
    };
    return m("div", {
      role: "search",
      className: "Search",
      "aria-label": this.attrs.a11yRoleLabel,
      onclick: () => {
        this.$('input').blur();
        setTimeout(() => openSearchModal(), 150);
      }
    }, m(Input, {
      type: "search",
      className: "Search-input",
      clearable: this.searchState.getValue(),
      clearLabel: app.translator.trans('core.lib.search.search_clear_button_accessible_label'),
      prefixIcon: "fas fa-search",
      "aria-label": this.attrs.label,
      readonly: true,
      placeholder: this.attrs.label,
      value: this.searchState.getValue(),
      onchange: value => {
        if (!value) this.searchState.clear();else this.searchState.setValue(value);
      },
      inputAttrs: {
        // for keyboard navigation, click event would be triggered on keydown
        onkeydown: e => {
          if (e.key === 'Enter') {
            e.preventDefault();
            this.$('input').blur() && openSearchModal();
          }
        }
      }
    }));
  }

  /**
   * A list of search sources that can be used to query for search results.
   */
}
flarum.reg.add('core', 'common/components/AbstractGlobalSearch', AbstractGlobalSearch);flarum.reg.addChunkModule('485', '7085', 'core', 'common/components/SearchModal');flarum.reg.addChunkModule('485', '7085', 'core', 'common/components/SearchModal');